<template>
  <div class="enrollment">
    <img class="background-circles_right" src="@Shared/assets/images/blue-circle-middle_yellow-circle-small.svg"
      alt="Background shapes" />
    <img class="background-circle_left" src="@Shared/assets/images/small-green-semi-circle.svg"
      alt="Background shapes" />
    <div class="vertical-progress-flow_container">
      <div class="vcore_row">
        <div class="vcore_col--xs--10">
          <div class="enrollment_intro" v-if="searchProviderView">
            <h1 class="enrollment_intro_title" tabindex="-1" v-focus>Let's get started</h1>
            <p class="enrollment_intro_body">
              You can easily enroll for HSF<span class="sup">&reg;</span> - we just need a little information to get started.
            </p>
          </div>
          <div class="enrollment_intro" v-else-if="guid && !searchProviderView">
            <h1 class="enrollment_intro_title" tabindex="-1" v-focus>Welcome to HSF<span class="sup">&reg;</span></h1>
            <p class="enrollment_intro_body">
              Commerce Bank offers patients and families a line of credit to help pay outstanding medical balances. A
              Health Services Financing account operates just like a monthly loan, with one monthly payment, allowing
              you to easily budget into your household finances.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="vertical-progress-flow_container vertical-progress-flow_full_width_sm_under">
      <div class="vcore_row">
        <div class="vcore_col--xs--12">
          <ErrorBox v-if="!guid && guidError" title="Sorry, we couldn't find your provider"
            errors="Please recheck your provider link or search for your provider by ZIP code below."
            class="guid-error-box" />
          <EnrollmentGUID v-if="guid && !searchProviderView"></EnrollmentGUID>
          <VerticalProgressFlow v-else>
            <ProviderSearch></ProviderSearch>
            <ProviderSelection></ProviderSelection>
            <div v-if="balanceFileEnrollmentEnabled != undefined">
              <ProviderStatementAuthenticate v-if="balanceFileEnrollmentEnabled == true && !noProviderSelected" :fromguid=false>
              </ProviderStatementAuthenticate>
              <ProviderStatementNonAuth v-if="balanceFileEnrollmentEnabled == false && !noProviderSelected"></ProviderStatementNonAuth>
            </div>
          </VerticalProgressFlow>
        </div>
      </div>
    </div>
    <div class="vertical-progress-flow_container" v-if="!selectedProvider.isCommerceCare">
      <div class="vcore_row">
        <div class="vcore_col--xs--12">
          <!-- Will need to check if a provider is selected as well -->
          <template v-if="(enrollmentCurrentSearchStepIndex >= 2 || guid)">
            <VerticalDivider></VerticalDivider>
            <div class="payment-estimator_wrapper">
              <PaymentEstimator :terms="selectedProvider.terms" :is-fixed-rate="selectedProvider.isFixedRate"
                :fixed-interest-rate="selectedProvider.fixedInterestRate" :rate-margin="selectedProvider.rateMargin"
                :step="'First Page'"></PaymentEstimator>
            </div>
            <VerticalDivider></VerticalDivider>
          </template>
        </div>
      </div>
    </div>
    <div class="vertical-progress-flow_container">
      <div class="vcore_row">
        <div class="enrollment_disclosures_wrapper">
          <div class="enrollment_disclosures vcore_col--xs--12" v-if="selectedProvider.isHSF">
            <template v-if="(enrollmentCurrentSearchStepIndex >= 2 || guid) && !selectedProvider.isFixedRate">
              <br />* APR accurate as of {{ todaysDate }}. For variable rates, the Annual Percentage Rate (APR)
              will vary with the Prime Rate, as published in The Wall Street Journal in its column
              called Money Rates on the last business day of each month.
            </template>


            <template v-else-if="!selectedProvider.isFixedRate">
              <br />*0% APR is not available with all healthcare providers. Please select a provider to
              see current rates and terms.
            </template>
            <br />
          </div>
          <div class="enrollment_disclosures vcore_col--xs--12"
            v-if="(enrollmentCurrentSearchStepIndex >= 2 || guid) && !selectedProvider.isCommerceCare">
            <br />** The information entered into the payment estimate calculator is
            intended for hypothetical purposes only and the results provided are
            wholly illustrative. Accuracy is not guaranteed. Your actual monthly
            payment amount will be provided to you after we receive your balance
            information from your health care provider but before you become
            obligated to pay, and on each billing statement thereafter.
          </div>
          <div class="enrollment_disclosures vcore_col--xs--12" v-if="(enrollmentCurrentSearchStepIndex >= 2 || guid)">
            <br /> Enrolling in financing through Commerce Bank is optional and there
            may be other repayment options or financial assistance programs available to you.
            Contact your Provider for information on repayment options.
          </div>
        </div>
      </div>
    </div>
    <EnrollmentFooter></EnrollmentFooter>
  </div>
</template>

<script>
import PaymentEstimator from "@Shared/components/PaymentEstimator";
import VerticalDivider from "@Shared/components/VerticalDivider";
import { scrollTop } from "@Shared/utils/Scroll";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import ErrorBox from "../../../Shared/components/ErrorBox";
import EnrollmentFooter from "../components/Enrollment/EnrollmentFooter";
import EnrollmentGUID from "../components/Enrollment/EnrollmentGUID";
import ProviderSearch from "../components/Enrollment/ProviderSearch";
import ProviderSelection from "../components/Enrollment/ProviderSelection";
import ProviderStatementAuthenticate from "../components/Enrollment/ProviderStatementAuthenticate";
import ProviderStatementNonAuth from "../components/Enrollment/ProviderStatementNonAuth";
import VerticalProgressFlow from "../components/VerticalProgressFlow";

export default {
  name: "Enrollment",
  components: {
    VerticalDivider,
    EnrollmentFooter,
    VerticalProgressFlow,
    ProviderSearch,
    ProviderSelection,
    ProviderStatementAuthenticate,
    PaymentEstimator,
    ProviderStatementNonAuth,
    EnrollmentGUID,
    ErrorBox
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "enrollmentCurrentSearchStepIndex",
      "enrollmentCurrentStepIndex",
      "guid",
      "guidError",
      "requiresUserAuth",
      "selectedProvider",
      "featureFlags",
      "searchProviderView"
    ]),
    todaysDate() {
      return moment()
        .format("MM/DD/YYYY");
    },
    balanceFileEnrollmentEnabled() {
      if (this.selectedProvider.balanceFileEnrollmentEnabled != undefined) {
        return this.selectedProvider.balanceFileEnrollmentEnabled;
      }

      return false;
    },
    console: () => console,
    noProviderSelected() {
      return Object.keys(this.selectedProvider).length === 0 &&
        this.selectedProvider.constructor === Object;
    }
  },
  mounted() {
    if (this.enrollmentCurrentSearchStepIndex === 0) {
      scrollTop(0, 300);
    }
    this.setEnrollmentSource(this.$router.currentRoute.query.source || "");
  },
  created() {
    // Attach onpopstate event handler
    window.onpopstate = function (event) {
      if (!(window.location.pathname.includes("frp-information")
        || window.location.pathname.includes("financing-information")
        || window.location.pathname.includes("confirmation"))) {
        window.location.reload(false);
      }
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.enrollmentCurrentStepIndex <= 1) {
      next(true);
    }
    else if (this.$route.fullPath.includes("guid")) {
      this.$router.replace({ name: "enroll" });
      this.setGuid(null);
      this.$router.push({ name: "enroll" });
      next(true);
    }
  },
  methods: {
    ...mapActions(["setGuid", "setEnrollmentSource"]),
  }
};
</script>

<style lang="scss" scoped>
.sup {
  font-size: 70%;
  vertical-align: super;
}

.enrollment {
  padding-bottom: 150px;

  @media (max-width: $grid-breakpoint-lg) {
    padding-bottom: 350px;
  }
}

.background-circles_right {
  position: absolute;
  top: 112px;
  right: 0;

  @media (max-width: $grid-breakpoint-xl) {
    max-width: 300px;
  }

  @media (max-width: $grid-breakpoint-lg) {
    max-width: 200px;
  }

  @media (max-width: $grid-breakpoint-sm) {
    max-width: 130px;
  }
}

.background-circle_left {
  position: absolute;
  top: 150px;
  left: 0;

  @media (max-width: $grid-breakpoint-xl) {
    max-height: 150px;
  }

  @media (max-width: $grid-breakpoint-lg) {
    max-height: 90px;
  }

  @media (max-width: $grid-breakpoint-sm) {
    max-height: 70px;
  }
}

.enrollment_intro {
  margin-bottom: 30px;

  .enrollment_intro_title {
    color: $color_dark-blue;
    margin-top: 60px;
    font-size: 45px;
    font-weight: 600;

    @media (max-width: $grid-breakpoint-sm) {
      font-size: 25px;
      margin-top: 20px;
    }
  }

  .enrollment_intro_body {
    font-size: 18px;
    line-height: 24px;
    margin-top: 20px;

    @media (max-width: $grid-breakpoint-sm) {
      margin-top: 15px;
      font-size: 16px;
      line-height: 22px;
    }
  }
}

.vertical-progress-flow_full_width_sm_under {
  @media (max-width: $grid-breakpoint-sm) {
    padding-left: 0;
    padding-right: 0;
  }
}

.payment-estimator_wrapper {
  padding: 10px 50px;

  @media (max-width: $grid-breakpoint-sm) {
    padding-left: 0;
    padding-right: 0;
  }
}

.enrollment_disclosures_wrapper {
  margin-top: 70px;
}

.enrollment_disclosures {
  font-size: 12px;
  line-height: 17px;
  color: $color_stephs-grey;
}
</style>